import React from 'react';
import { Box, Divider, Menu, MenuItem, Typography, capitalize } from '@mui/material';
import { LogOut } from 'lucide-react';
import ImageAvatar from 'ui-components/ImageAvatar';

const SwitchAccountsMenu = ({
  anchorEl,
  isMenuOpen,
  handleMenuClose,
  userAssociatedStartups,
  startup_id,
  handleLogOut,
}) => {
  // console.log(userAssociatedStartups, "userAssociatedStartups");
  // With a single account there is nothing to switch to, so the row is shown
  // as information only — no click, no hover, no pointer.
  const canSwitchAccounts = (userAssociatedStartups?.length || 0) > 1;

  return (
    <Menu
      anchorEl={anchorEl}
      open={isMenuOpen}
      onClose={handleMenuClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      sx={{
        '& .MuiPaper-root': {
          minWidth: '18.75rem',
          borderRadius: 3,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        },
        // MenuList adds its own 8px top/bottom padding, which breaks the even
        // rhythm the rows below set with their matching 0.875rem padding.
        '& .MuiList-root': {
          paddingTop: 0,
          paddingBottom: 0,
        },
      }}
    >
      {(
        <>
          <Box
            sx={{
              padding: '0.875rem 1rem',
              borderBottom: "thin solid #ebebeb !important"
            }}
          >
            <Typography
              sx={{
                fontSize: '0.875rem',
                fontWeight: 700,
                color: '#3c3c3c',
              }}
            >
              Your Accounts
            </Typography>
          </Box>

          {userAssociatedStartups?.map((startup) => (
            <MenuItem
              key={startup?.startup_id}
              disableRipple={!canSwitchAccounts}
              onClick={
                canSwitchAccounts
                  ? () => {
                      handleMenuClose({
                        _id: startup?.startup_id,
                        startup_name: startup?.startup_name,
                      });
                    }
                  : undefined
              }
              sx={{
                padding: '0.875rem 1rem',
                gap: 1.5,
                cursor: canSwitchAccounts ? 'pointer' : 'default',
                background:
                  startup?.startup_id === startup_id && canSwitchAccounts ? '#f3f0ff' : 'transparent',
                // borderLeft: startup?.startup_id === startup_id ? '4px solid #000000' : '4px solid transparent',
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: canSwitchAccounts
                    ? '#f9f9f9'
                    : startup?.startup_id === startup_id && canSwitchAccounts
                      ? '#f3f0ff'
                      : 'transparent',
                },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, width: '100%' }}>
                <Box sx={{ position: 'relative', flexShrink: 0 }}>
                  <ImageAvatar
                    style={{
                      width: '2.75rem',
                      height: '2.75rem',
                      borderRadius: '6px',
                      mixBlendMode: 'multiply',
                      // border: startup?.startup_id === startup_id ? '2px solid #000000' : 'none',
                    }}
                    src={startup?.startup_logo_path}
                  />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: '0.875rem',
                      fontWeight: 700,
                      color: '#3c3c3c',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {startup.startup_name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '0.75rem',
                      color: '#999',
                      marginTop: '0.125rem',
                    }}
                  >
                    {capitalize(startup.user_role)}
                  </Typography>
                  {/* {startup?.startup_id === startup_id && (
                    <Typography
                      sx={{
                        fontSize: '0.7rem',
                        color: '#000000',
                        fontWeight: 600,
                        marginTop: '0.125rem',
                      }}
                    >
                      Active
                    </Typography>
                  )} */}
                </Box>
                {/* {startup?.startup_id === startup_id && (
                  <Box
                    sx={{
                      width: '6px',
                      height: '6px',
                      borderRadius: '50%',
                      backgroundColor: '#000000',
                      flexShrink: 0,
                    }}
                  />
                )} */}
              </Box>
            </MenuItem>
          ))}

          {/* <Divider sx={{ margin: 0, borderColor: '#ebebeb !important' }} /> */}

          {/* Same LogOut glyph as the sidebar footer row, so the two entry
              points to signing out read as the same action. */}
          <MenuItem
            onClick={handleLogOut}
            sx={{
              padding: '0.875rem 1rem',
              gap: 1.25,
              color: '#3c3c3c',
              '&:hover': { backgroundColor: '#f9f9f9' },
              borderTop: "thin solid #ebebeb !important"
            }}
          >
            <LogOut size={16} />
            <Typography sx={{ fontSize: '0.875rem', fontWeight: 700 }}>
              Logout
            </Typography>
          </MenuItem>
        </>
      )}
    </Menu>
  );
};

export default SwitchAccountsMenu;
